import React, { Component } from "react";
import Axios from "axios";
import { configuration } from "../../appConfig";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { updateJsonData } from "../../redux/actions/updateJsonData";
import { Modal, ModalBody } from "reactstrap";
import DatePicker from "react-date-picker";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
// import "../newReportSwissFull.css"
// import "../newReportPrintPDF.css"
// import "../newReportSwissFullResponsive.css"
import "../dnsReport.css";
import "../dnsReportPrintMode.css";
import "../dnsReportResponsive.css";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class newswiss_CustomerInfoTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      orderNumber: "",
      words: {},
      lang: "gb",
      kilometerStand: "",
      comment: "",
      manufacturer: "",
      regNo: "",
      model: "",
      color: "",
      Name: "",
      estimateId: "",
      jsondata: [],
      contractor: "",
      ScannerLocation: "",
      actualVIN: "",
      claimNumber: "",
      customerCompany: "",
      modal_break: false,
      isUpdateInfo: false,
      AuthorizedName: "",
      email: "",
      mobileNumber: "",
      Inv1: "",
      stammnummerName: "",
    };
    this.flatpickrRef = React.createRef();
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      const lang = localStorage.getItem("lang") || "en";
      this.setState({ words: res.data, lang }, () => {
        this.updateLocale();
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang;
    if (lang === "fr") {
      currentLang = "ch-fr";
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][currentLang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else if (nextProps.Authorized !== prevState.Authorized) {
      return { Authorized: nextProps.Authorized };
    } else return null;
  }
  componentDidMount() {
    this.customerInfo();
    this.getLang();
    this.updateFinalData();
  }

  updateFinalData() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    Axios.get(`${configuration.getData}?vin=${vin}&partnerId=${partnerId}`)
      .then((r) => {
        if (r.data) {
          const removeLeadingSpace = (str) => str ? str.replace(/^\s+/, '') : '';
          let updatedCustomerCompany = r.data.CustomerCompany || "";
          const contractor = r.data.InsurenceName || "";
         
          const customerFullName = `${removeLeadingSpace(r.data.CustomerVorname)} ${removeLeadingSpace(r.data.CustomerName)}`;

          // Define the mapping of contractor values to customerCompany values
          const replacements = [
            { contractor: "la Mobiliare", company: "la Mobiliare" },
            { contractor: "la Mobilière", company: "la Mobilière" },
            { contractor: "die Mobiliar", company: "die Mobiliar" },
            { contractor: "Mobiliare", company: "la Mobiliare" },
            { contractor: "Mobilière", company: "la Mobilière" },
            { contractor: "Mobiliar", company: "die Mobiliar" },
            { contractor: "mobiliare", company: "la mobiliare" },
            { contractor: "mobilière", company: "la mobilière" },
            { contractor: "mobiliar", company: "die mobiliar" },
          ];

          replacements.forEach((replacement) => {
            if (
              contractor.includes(replacement.contractor) &&
              !updatedCustomerCompany.includes(replacement.company)
            ) {
              updatedCustomerCompany = replacement.company;
            }
          });

          if (partnerId == "Helvetia-001") {
            let helvetia = "Helvetia".toLocaleLowerCase();
            let smile = "Smile".toLocaleLowerCase();
            const HelvetiaReplacment = [
              { contractor: helvetia, company: "Helvetia Versicherung" },
              { contractor: smile, company: "Helvetia Versicherung" },
            ];
            HelvetiaReplacment.forEach((replacement) => {
              if (
                contractor
                  .toLocaleLowerCase()
                  .includes(replacement.contractor) &&
                !updatedCustomerCompany.includes(replacement.company)
              ) {
                updatedCustomerCompany = replacement.company;
              }
            });
          }

          // this.setState({
          //   jsondata: r.data,
          //   manufacturer: r.data.Make || "",
          //   regNo: r.data.RegNo || "",
          //   model: r.data.Model || "",
          //   color: r.data.Color || "",
          //   Name: customerFullName || "",
          //   comment: r.data.Comments || "",
          //   estimateId: r.data.OrderNo || "",
          //   actualVIN: r.data.ActualVin || "",
          //   Authorized: r.data.Authorized || "",
          //   ScannerLocation: r.data.ScannerLocation || "",
          //   contractor: r.data.Client || r.data.InsurenceName || "",
          //   claimNumber: r.data.ClaimNo || "",
          //   customerCompany: updatedCustomerCompany,
          //   kilometerStand: r.data.KilometerReading || "",
          //   AuthorizedName: r.data.AuthorizedName || "",
          //   stammnummerName: r.data.RcBookNo || "",
          //   Inv1: r.data.Inv1 || "",
          //   email: r.data.Email || "",
          //   mobileNumber: r.data.TelPrivate || "",
          // });
          this.setState({
            jsondata: r.data,
            manufacturer: removeLeadingSpace(r.data.Make),
            regNo: removeLeadingSpace(r.data.RegNo),
            model: removeLeadingSpace(r.data.Model),
            color: removeLeadingSpace(r.data.Color),
            Name: removeLeadingSpace(customerFullName),
            comment: removeLeadingSpace(r.data.Comments),
            estimateId: removeLeadingSpace(r.data.OrderNo),
            actualVIN: removeLeadingSpace(r.data.ActualVin),
            Authorized: r.data.Authorized || "",
            ScannerLocation: removeLeadingSpace(r.data.ScannerLocation) || "",
            contractor: removeLeadingSpace(r.data.Client || r.data.InsurenceName),
            claimNumber: removeLeadingSpace(r.data.ClaimNo),
            customerCompany: removeLeadingSpace(r.data.CustomerCompany),
            kilometerStand: removeLeadingSpace(r.data.KilometerStand),
            AuthorizedName: removeLeadingSpace(r.data.AuthorizedName),
            stammnummerName: removeLeadingSpace(r.data.RcBookNo),
            Inv1: r.data.Inv1 || "",
            email: removeLeadingSpace(r.data.CustomerEmail),
            mobileNumber: removeLeadingSpace(r.data.TelPrivate),
          });
          // if (partnerId == "Helvetia-001") {
          //   this.setState({
          //     claimNumber: r.data.OrderNo,
          //   });
          // }

          this.props.fullData.Client = contractor;
          this.props.fullData.CustomerCompany = updatedCustomerCompany;
          this.props.fullData.ClaimNo = r.data.ClaimNo || "";
          this.props.fullData.RegNo = r.data.RegNo || "";
          this.props.fullData.Make = r.data.Make || "";
          this.props.fullData.ActualVin = r.data.ActualVin || "";
          this.props.fullData.Model = r.data.Model || "";
          this.props.fullData.Color = r.data.Color || "";
          this.props.fullData.PartnerName = r.data.CustomerName || "";
          this.props.fullData.Comments = r.data.Comments || "";
          this.props.fullData.email = r.data.email || "";
          this.props.fullData.TelPrivate = r.data.TelPrivate || "";
        }
      })
      .then(async () => {
        if (partnerId) {
          const res = await Axios.get(
            `${configuration.getSingleQRDetails}?partnerId=${partnerId}&vin=${vin}&qr_type=1`
          );
          if (res.data.data.length) {
            this.setState({
              estimateId:
                this.state.estimateId || res.data.data[0].estimateId || "",
              manufacturer:
                this.state.manufacturer || res.data.data[0].make || "",
              regNo: this.state.regNo || res.data.data[0].reg || "",
              model: this.state.model || res.data.data[0].model || "",
              color: this.state.color || res.data.data[0].color || "",
              // Name: this.state.Name || res.data.data[0].  omerName || '',
              comment: this.state.comment || res.data.data[0].comment || "",
              contractor:
                this.state.contractor || res.data.data[0].client || res.data.data[0].InsurenceName || "",
              claimNumber:
                this.state.claimNumber || res.data.data[0].claimNumber || "",
              customerCompany:
                this.state.customerCompany ||
                res.data.data[0].customerCompany ||
                "",
              actualVIN: this.state.actualVIN || res.data.data[0].vin || "",
              InsurenceName: res.data.data[0].InsurenceName || "",
            });
            this.props.fullData.Client =
              this.state.contractor || res.data.data[0].client || res.data.data[0].InsurenceName || "";
            this.props.fullData.ClaimNo =
              this.state.claimNumber || res.data.data[0].claimNumber || "";
            this.props.fullData.CustomerCompany =
              this.state.customerCompany ||
              res.data.data[0].customerCompany ||
              "";
            this.props.fullData.RegNo =
              this.state.regNo || res.data.data[0].reg || "";
            this.props.fullData.Make =
              this.state.manufacturer || res.data.data[0].make || "";
            this.props.fullData.ActualVin =
              this.state.actualVIN || res.data.data[0].vin || "";
            this.props.fullData.Model =
              this.state.model || res.data.data[0].model || "";
            this.props.fullData.Color =
              this.state.color || res.data.data[0].color || "";
            this.props.fullData.PartnerName =
              this.state.Name || res.data.data[0].customerName || "";
            this.props.fullData.Comments =
              this.state.comment || res.data.data[0].comment || "";
          }
        }
      })
      .then(async () => {
        if (partnerId) {
          const res = await Axios.get(
            `${configuration.getCustomerInfo}?partnerId=${partnerId}&vin=${vin}`
          );
          if (res.data.length) {
            this.setState({
              data: res.data[0],
              kilometerStand:
                this.state.kilometerStand || res.data[0].kilometerStand || "",
              estimateId: this.state.estimateId || res.data[0].orderid || "",
              manufacturer:
                this.state.manufacturer || res.data[0].manufacturer || "",
              regNo: this.state.regNo || res.data[0].regNo || "",
              model: this.state.model || res.data[0].model || "",
              color: this.state.color || res.data[0].color || "",
              // Name: this.state.Name || res.data[0].Name || '',
              comment: this.state.comment || res.data[0].comment || "",
              contractor:
                this.state.contractor || res.data[0].insurenceName || "",
              InsurenceName: res.data[0].InsurenceName || "",
              email: !this.state.email
                ? res.data[0].email || ""
                : this.state.email,
              mobileNumber: !this.state.mobileNumber
                ? res.data[0].customerNumber || ""
                : this.state.mobileNumber,
            });
            localStorage.setItem("InsurenceName", res.data[0].insurenceName);
          }
        }
      })
      .catch((err) => console.log(err));
  }

  customerInfo = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({
          data: res.data[0],
          orderNumber: res.data[0].orderid,
        });
        // localStorage.setItem("isScanListRecord", res.data[0].isScanListRecord);
        localStorage.setItem("InsurenceName", res.data[0].insurenceName);
      } else {
        let clr = {
          vinNumber: "",
          rcBookNo: "",
          manufacturer: "",
          customerNumber: "",
          emailAddress: "",
          Name: "",
          model: "",
          street: "",
          color: "",
          regNo: "",
          customerCity: "",
          postalCode: "",
          abc: "",
        };
        this.setState({ data: clr });
      }
    } else {
    }
  };

  //   handleDateChange = (date) => {
  //     if (date) {
  //       const formattedDate = this.formatDate(date);
  //       this.setState({ Inv1: formattedDate });
  //     } else {
  //       this.setState({ Inv1: null });
  //     }
  //   };

  //   formatDate = (date) => {
  //     if (!(date instanceof Date) || isNaN(date)) {
  //       return "";
  //     }
  //     const day = String(date.getDate()).padStart(2, "0");
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const year = date.getFullYear();
  //     return `${day}.${month}.${year}`;
  //   };

  handleDateChange = (selectedDates, e) => {
    if (selectedDates.length > 0) {
      const formattedDate = this.formatDate(selectedDates[0]);
      this.setState({ Inv1: formattedDate });
    } else {
      this.setState({ Inv1: "" });
    }
  };

  formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      return "";
    }
    return moment(date).format("DD.MM.YYYY");
  };

  handleChange = (e) => {
    const removeLeadingSpace = (str) => str ? str.replace(/^\s+/, '') : '';
    const { name, value } = e.target;
    let newValue = value;
    let updatedCustomerCompany = this.state.customerCompany;
    const partnerId = localStorage.getItem("partnerId");

    if (name === "contractor") {
      // Define the mapping of contractor values to customerCompany values
      const replacements = [
        { contractor: "la Mobiliare", company: "la Mobiliare" },
        { contractor: "la Mobilière", company: "la Mobilière" },
        { contractor: "die Mobiliar", company: "die Mobiliar" },
        { contractor: "Mobiliare", company: "la Mobiliare" },
        { contractor: "Mobilière", company: "la Mobilière" },
        { contractor: "Mobiliar", company: "die Mobiliar" },
        { contractor: "mobiliare", company: "la mobiliare" },
        { contractor: "mobilière", company: "la mobilière" },
        { contractor: "mobiliar", company: "die mobiliar" },
      ];

      replacements.forEach((replacement) => {
        if (
          value.includes(replacement.contractor) &&
          !this.state.customerCompany.includes(replacement.company)
        ) {
          updatedCustomerCompany = replacement.company;
        }
      });

      if (partnerId == "Helvetia-001") {
        let helvetia = "Helvetia".toLocaleLowerCase();
        let smile = "Smile".toLocaleLowerCase();
        const HelvetiaReplacment = [
          { contractor: helvetia, company: "Helvetia Versicherung" },
          { contractor: smile, company: "Helvetia Versicherung" },
        ];
        HelvetiaReplacment.forEach((replacement) => {
          if (
            value.toLocaleLowerCase().includes(replacement.contractor) &&
            !this.state.customerCompany.includes(replacement.company)
          ) {
            updatedCustomerCompany = replacement.company;
          }
        });
      }

      this.setState({
        contractor: newValue,
        customerCompany: updatedCustomerCompany,
      });

      this.props.fullData.Client = newValue;
      this.props.fullData.CustomerCompany = updatedCustomerCompany;
    } else {
      this.setState({
        [name]: removeLeadingSpace(newValue),
      });

      // Update the corresponding property in fullData
      switch (name) {
        case "contractor":
          this.props.fullData.InsurenceName = newValue;
          break;
        case "claimNumber":
          this.props.fullData.ClaimNo = newValue;
          break;
        case "customerCompany":
          this.props.fullData.CustomerCompany = newValue;
          break;
        case "regNo":
          this.props.fullData.RegNo = newValue;
          break;
        case "manufacturer":
          this.props.fullData.Make = newValue;
          break;
        case "actualVIN":
          this.props.fullData.ActualVin = newValue;
          break;
        case "model":
          this.props.fullData.Model = newValue;
          break;
        case "kilometerStand":
          this.props.fullData.kilometerStand = newValue;
          break;
        case "color":
          this.props.fullData.Color = newValue;
          break;
        case "ScannerLocation":
          this.props.fullData.ScannerLocation = newValue;
          break;
        case "Name":
          this.props.fullData.CustomerName = newValue;
          break;
        case "comment":
          this.props.fullData.Comments = newValue;
          break;
        case "stammnummerName":
          this.props.fullData.RcBookNo = newValue;
          break;
        default:
          break;
      }
    }

    this.props.updateJsonData(this.props.fullData);
  };

  handleSave = () => {
    // make api req here
    const removeLeadingSpace = (str) => str ? str.replace(/^\s+/, '') : '';
  const nameParts = this.state.Name.split(" ");
  const firstName = removeLeadingSpace(nameParts[0]);
  const lastName = nameParts.slice(1).join(" ");
    const { data } = this.state;
    this.setState({
      modal_break: true,
    });
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url =
      configuration.PostCustomerInfo +
      "?partnerId=" +
      partnerId +
      "&vin=" +
      vin.split("_")[0];
    const qrUrl =
      configuration.updateQRInfo +
      "?partnerId=" +
      partnerId +
      "&vin=" +
      vin.split("_")[0];
    const updatedData = {
      // Name: this.state.Name,
      Name: `${firstName} ${lastName}`,
      color: this.state.color,
      comment: this.state.comment,
      kilometerStand: this.state.kilometerStand,
      customerCity: data.customerCity || "",
      customerNumber: data.customerNumber || "",
      //   "emailAddress": data.emailAddress || "",
      manufacturer: this.state.manufacturer,
      email: this.state.email,
      mobileNumber: this.state.mobileNumber,
      model: this.state.model,
      partnerId: partnerId,
      postalCode: data.postalCode || "",
      regNo: this.state.regNo,
      vinNumber: vin,
      rcBookNo: this.state.stammnummerName,
      //   "street":"",
      estimateId: this.state.estimateId,
      Inv1: this.state.Inv1,
    };
    let qrPayload = {
      ...updatedData,
      InsurenceName: this.state.contractor || "",
      Client: this.props.fullData.Client || "",
      ClaimNo: this.props.fullData.ClaimNo || "",
      CustomerCompany: this.props.fullData.CustomerCompany || "",
      rcBookNo: this.state.stammnummerName,
    };
    Axios.post(qrUrl, qrPayload)
      .then((res) => {
        if (res.data) {
          Axios.post(url, updatedData).then((res) => {
            this.state.jsondata.CustomerName = lastName;
            this.state.jsondata.CustomerVorname = firstName;
            this.state.jsondata.Color = this.state.color;
            this.state.jsondata.Comments = this.state.comment;
            this.state.jsondata.kilometerStand = this.state.kilometerStand;
            this.state.jsondata.Make = this.state.manufacturer;
            this.state.jsondata.Model = this.state.model;
            this.state.jsondata.RegNo = this.state.regNo;
            this.state.jsondata.OrderNo = this.state.estimateId;
            this.state.jsondata.ActualVin = this.state.actualVIN;
            this.state.jsondata.Inv1 = this.state.Inv1;

            //   this.state.jsondata.contractor = this.state.contractor;
            this.state.jsondata.ScannerLocation = this.state.ScannerLocation;
            this.setState({ jsondata: this.state.jsondata });

            Axios.get(
              `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
            )
              .then((r) => {
                if (r.data) {
                  let payload = {
                    ...r.data,
                    CustomerName: lastName ? lastName : "",
                    CustomerVorname : firstName ? firstName : "",
                    Color: this.state.color,
                    Comments: this.state.comment,
                    KilometerStand: this.state.kilometerStand,
                    Make: this.state.manufacturer,
                    Model: this.state.model,
                    RegNo: this.state.regNo,
                    OrderNo: this.state.estimateId,
                    ActualVin: this.state.actualVIN,
                    //   ScannerLocation : this.state.ScannerLocation,
                    ScannerLocation: this.state.ScannerLocation || "",
                    CustomerEmail: this.state.email || "",
                    TelPrivate: this.state.mobileNumber || "",
                    Client: this.state.contractor,
                    ClaimNo: this.state.claimNumber,
                    CustomerCompany: this.state.customerCompany,
                    Inv1: this.state.Inv1,
                    InsurenceName: this.state.contractor,
                    RcBookNo: this.state.stammnummerName,
                    PartnerID: partnerId
                  };
                  const jsonurl =
                    configuration.PostEditorChanges +
                    `?partnerId=${localStorage.getItem(
                      "partnerId"
                    )}&vin=${localStorage.getItem(
                      "selectedFile"
                    )}&TabViewUpdated=${!this.state.jsondata.TabViewUpdated}`;

                  Axios.post(jsonurl, payload).then((res) => {
                    // this.props.getJSONData(vin);
                    Toast.fire({
                      type: "success",
                      title: "Data saved successfully",
                    });
                    this.setState({
                      modal_break: false,
                      isUpdateInfo: true,
                    });
                  });
                }
              })
              .catch((err) => {
                // alert(err)
                Toast.fire({
                  type: "error",
                  title: "Something went wrong",
                });
              });
            Toast.fire({
              type: "success",
              title: "Data saved successfully",
            });

            this.setState({ data });
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong",
        });
        this.setState({
          modal_break: false,
        });
      });
  };

  handleLangChange = (event) => {
    const selectedLang = event.target.value;
    localStorage.setItem("lang", selectedLang);
    this.setState({ lang: selectedLang }, () => {
      this.updateLocale();
    });
  };
  updateLocale = () => {
    const { lang } = this.state;

    // Dynamically set month and weekday names based on the selected language
    const locale = {
      firstDayOfWeek: 1, // Set Monday as the first day of the week
      weekdays: {
        shorthand: [
          this.lang("sun"),
          this.lang("mo"),
          this.lang("tue"),
          this.lang("wed"),
          this.lang("thu"),
          this.lang("fri"),
          this.lang("sat"),
        ],
        longhand: [
          this.lang("sunday"),
          this.lang("monday"),
          this.lang("tuesday"),
          this.lang("wednesday"),
          this.lang("thursday"),
          this.lang("friday"),
          this.lang("saturday"),
        ],
      },
      months: {
        shorthand: [
          this.lang("january"),
          this.lang("february"),
          this.lang("march"),
          this.lang("april"),
          this.lang("may"),
          this.lang("june"),
          this.lang("july"),
          this.lang("august"),
          this.lang("september"),
          this.lang("october"),
          this.lang("november"),
          this.lang("december"),
        ],
        longhand: [
          this.lang("january"),
          this.lang("february"),
          this.lang("march"),
          this.lang("april"),
          this.lang("may"),
          this.lang("june"),
          this.lang("july"),
          this.lang("august"),
          this.lang("september"),
          this.lang("october"),
          this.lang("november"),
          this.lang("december"),
        ],
      },
    };

    if (this.flatpickrRef.current) {
      this.flatpickrRef.current.flatpickr.set("locale", locale);
    }
  };

  render() {
    const { data, Authorized, Inv1 } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    return (
      <div
        className={`${
          this.props.viewType === "TabView" ? "container-fluid" : "container"
        }`}
      >
        <div
          className={`row allInformation-table ${
            this.props.viewType === "TabView"
              ? "tab-view-wrapper-all-information-table p-0"
              : "title-row-main"
          }`}
        >
          <div
            className={`col-lg-6 allInformation-table-col-one ${
              this.props.viewType === "TabView" ? "" : "col-zero"
            }`}
          >
            <div className="all-information-table">
              {localStorage.getItem("lang") === "fr" ||
              localStorage.getItem("lang") === "it" ||
              localStorage.getItem("client") === "POLAND" ||
              localStorage.getItem("client") === "POLAND_HAIL" ||
              localStorage.getItem("client") === "POLAND_GD" ? (
                <h3 className="report-title">
                  {this.lang("Information")}
                  <span> {this.lang("General")}</span>{" "}
                </h3>
              ) : (
                <h3 className="report-title">
                  {this.lang("General")}
                  <span> {this.lang("Information")}</span>{" "}
                </h3>
              )}
              {/* {localStorage.getItem("lang") == "ch" && <h3 className="two-color-title-tag title-tag-one">
                                    {this.lang("General")}<span> {this.lang("Information")}</span>{" "}
                                </h3>}
                                {localStorage.getItem("lang") == "fr" && <h3 className="two-color-title-tag title-tag-one">
                                    {this.lang("Information")}<span> {this.lang("General")}</span>{" "}
                                </h3>}
                                {localStorage.getItem("lang") == "it" && <h3 className="two-color-title-tag title-tag-one">
                                    {this.lang("Information")}<span> {this.lang("General")}</span>{" "}
                                </h3>} */}

              <div className="all-information-table-content-wrapper">
                <table>
                  <tbody>
                    {/* Contractor::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Insurance Client")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                value={this.state.contractor}
                                onChange={this.handleChange}
                                name="contractor"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                                disabled={Authorized}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.contractor}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Contractor::End */}

                    {/* Insurance_Company::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Customer Company")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.customerCompany}
                                onChange={this.handleChange}
                                name="customerCompany"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                                disabled={Authorized}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.customerCompany}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Insurance_Company::End */}
                    {/* Customer_Name::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Customer Name")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.Name}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="Name" // onBlur={this.handleBlur}
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">{this.state.Name}</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Customer_Name::End */}

                    {/* Claim_Number::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Claim number")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.claimNumber}
                                onChange={this.handleChange}
                                name="claimNumber"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                                disabled={Authorized}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.claimNumber}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Claim_Number::End */}

                    {/* Scanner_number::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Scanner Location")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.ScannerLocation}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="ScannerLocation"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.ScannerLocation}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Scanner_number::End */}

                    {/* Experte::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {this.lang("Experte")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.AuthorizedName}
                                // disabled={!this.props.viewType || Authorized}
                                disabled
                                onChange={this.handleChange}
                                name="AuthorizedName"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.AuthorizedName}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Experte::End */}

                    {/* stammnummer::Start */}
                    {this.props.viewType == "TabView" &&  this.props.viewType != undefined &&(
                     <tr>
                      <td>
                        <p className="table-text-gray">
                          {(client == "US" || client == "CANADA") ? this.lang("Customer Id") : this.lang("stammnummer")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                              <input
                                className="m-0 p-0 "
                                value={this.state.stammnummerName}
                                disabled={!this.props.viewType || Authorized}
                                // disabled
                                onChange={this.handleChange}
                                name="stammnummerName"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                          </div>
                        </div>
                      </td>
                    </tr>
                    )}
                    {/* stammnummer::End */}

                    {/* Notes::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">{this.lang("Notes")}</p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.comment}
                                title={this.state.comment}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                // onBlur={this.handleBlur}
                                name="comment"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p
                                className="m-0 p-0 "
                                title={this.state.comment}
                                style={{ textTransform: "none" }}
                              >
                                {this.state.comment
                                  ? this.state.comment.length > 104
                                    ? `${this.state.comment.substring(
                                        0,
                                        100
                                      )} ...`
                                    : this.state.comment.substring(0, 101)
                                  : ""}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Notes::End */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className={`col-lg-6 allInformation-table-col-two ${
              this.props.viewType === "TabView" ? "" : "col-zero"
            }`}
          >
            <div className="all-information-table">
              <h3 className="report-title">
                {localStorage.getItem("client") === "POLAND" &&
                localStorage.getItem("lang") !== "fr" &&
                localStorage.getItem("lang") !== "fr-ch" &&
                localStorage.getItem("lang") !== "ch-fr" ? (
                  <>
                    {this.lang("Information")}
                    <span> {this.lang("VEHICLE")}</span>
                  </>
                ) : (
                  <>
                    {this.lang("VEHICLE")}
                    <span> {this.lang("Information")}</span>
                  </>
                )}
              </h3>

              <div className="all-information-table-content-wrapper">
                <table>
                  <tbody>
                    {/* Make::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">{this.lang("Make")}</p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.manufacturer}
                                onChange={this.handleChange}
                                name="manufacturer"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                                disabled={Authorized}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.manufacturer}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Make::End */}

                    {/* Model::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray"> {this.lang("Model")}</p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.model}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="model"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">{this.state.model}</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Model::End */}

                    {/* color::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray"> {this.lang("Color")}</p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.color}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="color"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">{this.state.color}</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* color::End */}

                    {/* VIN:Chassis number:Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray"> {this.lang("VIN")}</p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.actualVIN}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="actualVIN"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {this.state.actualVIN ||
                                  localStorage
                                    .getItem("selectedFile")
                                    .split("_")[0]}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* VIN:Chassis number:End */}

                    {/* License plate::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {" "}
                          {this.lang("License_Plate")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.regNo}
                                onChange={this.handleChange}
                                name="regNo"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                                disabled={Authorized}
                              />
                            ) : (
                              <p className="m-0 p-0 ">{this.state.regNo}</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* License plate::End */}

                    {/* Placing_On_The_Market::Start */}
                    <tr>
                      <td>
                        {/* <p className="table-text-gray">1. {this.lang("First registration")}</p> */}
                        <p className="table-text-gray">
                          {this.lang("First registration")}
                        </p>
                        {/* <p className="table-text-gray">
                                                    {client !== "POLAND" && "1 "}
                                                    {this.lang("First registration")}
                                                </p> */}
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {/* {
                                                            this.props.viewType === 'TabView' ?
                                                                <input className="m-0 p-0 "
                                                                    disabled
                                                                    style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                                                />
                                                                :
                                                                <p className="m-0 p-0 ">{this.state.jsondata.Inv1}</p>
                                                        } */}
                            {this.props.viewType === "TabView" ? (
                              //     <input
                              //     className="m-0 p-0 "
                              //     value={this.state.Inv1}
                              //     disabled={!this.props.viewType || Authorized}
                              //     onChange={this.handleChange}
                              //     name="Inv1"
                              //     style={{
                              //         background: "none",
                              //         outline: "none",
                              //         border: "none",
                              //         width: "100%",
                              //     }}
                              // />
                              <div className="main_datepicker_wrapper">
                                {
                                    Authorized ? (

                                        <input 
                                        className="m-0 p-0"
                                        placeholder="DD.MM.YYYY"
                                       value={Inv1}
                                       style={{
                                        background: "none",
                                        outline: "none",
                                        border: "none",
                                        width: "100%",
                                      }}
                                       disabled={Authorized}
                                        />
                                    ) : (
                                      <Flatpickr
                                      ref={this.flatpickrRef}
                                      placeholder="DD.MM.YYYY"
                                      className="filter-date-picker"
                                      options={{
                                        locale: {
                                          firstDayOfWeek: 1,
                                          weekdays: {
                                            shorthand: [
                                              this.lang("sun"),
                                              this.lang("mon"),
                                              this.lang("tue"),
                                              this.lang("wed"),
                                              this.lang("thu"),
                                              this.lang("fri"),
                                              this.lang("sat"),
                                            ],
                                            longhand: [
                                              this.lang("sunday"),
                                              this.lang("monday"),
                                              this.lang("tuesday"),
                                              this.lang("wednesday"),
                                              this.lang("thursday"),
                                              this.lang("friday"),
                                              this.lang("saturday"),
                                            ],
                                          },
                                          months: {
                                            shorthand: [
                                              this.lang("january"),
                                              this.lang("february"),
                                              this.lang("march"),
                                              this.lang("april"),
                                              this.lang("may"),
                                              this.lang("june"),
                                              this.lang("july"),
                                              this.lang("august"),
                                              this.lang("september"),
                                              this.lang("october"),
                                              this.lang("november"),
                                              this.lang("december"),
                                            ],
                                            longhand: [
                                              this.lang("january"),
                                              this.lang("february"),
                                              this.lang("march"),
                                              this.lang("april"),
                                              this.lang("may"),
                                              this.lang("june"),
                                              this.lang("july"),
                                              this.lang("august"),
                                              this.lang("september"),
                                              this.lang("october"),
                                              this.lang("november"),
                                              this.lang("december"),
                                            ],
                                          },
                                        },
                                        altInput: true,
                                          dateFormat: "DD.MM.YYYY",
                                          altFormat: "DD.MM.YYYY",
                                          allowInput: false, // Disable manual input
                                          parseDate: (datestr, format) => {
                                            return moment(
                                              datestr,
                                              format,
                                              true
                                            ).toDate();
                                          },
                                          formatDate: (date, format) => {
                                            return moment(date).format(format);
                                          },
                                        }}
                                        value={
                                          Inv1
                                            ? moment(Inv1, "DD.MM.YYYY").toDate()
                                            : null
                                        }
                                        onChange={this.handleDateChange}
                                        onReady={(
                                          selectedDates,
                                          dateStr,
                                          instance
                                        ) => {
                                          instance.input.setAttribute(
                                            "readonly",
                                            true
                                          );
                                        }}
                                      />
                                    )
                                }
                               
                              </div>
                                  ) : (
                                    <p className="m-0 p-0 ">
                                      {this.state.jsondata.Inv1 || ""}
                                    </p>
                                  )
                            }
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* Placing_On_The_Market::End */}

                    {/* KilometerStand::Start */}
                    <tr>
                      <td>
                        <p className="table-text-gray">
                          {" "}
                          {(client == "US" || client == "CANADA") ? this.lang("Odometer") : this.lang("Kilometer Stand")}
                        </p>
                      </td>
                      <td>
                        <div className="table-editable-input">
                          <div className="text-heading-light-wrapper">
                            {this.props.viewType === "TabView" ? (
                              <input
                                className="m-0 p-0 "
                                value={this.state.kilometerStand}
                                disabled={!this.props.viewType || Authorized}
                                onChange={this.handleChange}
                                name="kilometerStand"
                                style={{
                                  background: "none",
                                  outline: "none",
                                  border: "none",
                                  width: "100%",
                                }}
                              />
                            ) : (
                              <p className="m-0 p-0 ">
                                {data.kilometerStand || ""}
                              </p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {/* KilometerStand::End */}

                    {/* Vehicle expert::Start */}
                    {/* <tr>
                                            <td>
                                                <p className="table-text-gray">{this.lang("Vehicle expert")}</p>
                                            </td>
                                            <td>
                                                <div className="table-editable-input">
                                                    <div className="text-heading-light-wrapper">
                                                    {
                                                            this.props.viewType === 'TabView' ?
                                                                <input className="m-0 p-0 "
                                                                    disabled
                                                                    style={{ background: 'none', outline: 'none', border: 'none', width: "100%" }}
                                                                />
                                                                :
                                                                <p className="m-0 p-0 "></p>
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                        </tr> */}
                    {/* Vehicle expert::End */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="d-list-middle row p-0 customer-info-main new_swiss_table_customer_info">
          {this.props.viewType === "TabView" && (
            <div className="row update-info-information-btn-row">
              <div className="col-12 p-0 theme-btn-wrapper">
                <button
                  className={
                    this.state.isUpdateInfo
                      ? "theme-btn-hover mr-2 mb-1 iskI-amag-active"
                      : "theme-btn-hover mb-1"
                  }
                  // style={{
                  //   // padding:'5px',
                  //   backgroundColor:'#F20000',
                  //   padding: "5px 10px",
                  //   color : 'white',
                  //   border: "none",
                  //   borderRadius: "5px",
                  //   fontSize: "16px",
                  // }}
                  disabled={Authorized}
                  onClick={this.handleSave}
                >
                  {this.lang("Update Info")}
                </button>
              </div>
            </div>
          )}
        </div>
        <Modal
          centered
          size="lg"
          isOpen={this.state.modal_break}
          className="authorise_modalpopup"
          backdrop="static"
          toggle={() => this.setState({ modal_break: false })}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>
                {this.lang("save in progress")}
                <span className="dot-flashing"></span>
              </b>
            </p>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    fullData: props.jsonData,
  };
};
export default connect(mapStateToProps, { updateJsonData })(
  newswiss_CustomerInfoTable
);
